import { render, staticRenderFns } from "./NAVOnlineInvoiceInterfaceSettings.yaml?vue&type=template&id=1a7b1e04&component"
import script from "./NAVOnlineInvoiceInterfaceSettings.yaml?vue&type=script&lang=ts&component"
export * from "./NAVOnlineInvoiceInterfaceSettings.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports